import { Checkbox } from '@mantine/core';
import { useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { TravelRequestSchema, defaultTravelExpenseValues } from '@/module/Travel/Request/model/TravelRequestSchema';
import { mobilitySupportExcludedMotivations } from '@/module/Travel/Request/model/TravelRequestTypes';

export interface TravelMobilitySupportCardProps {
  isSubmitting?: boolean;
}

export function TravelMobilitySupportCard(props: TravelMobilitySupportCardProps) {
  const { isSubmitting } = props;
  const { t } = useTranslation();
  const { control, setValue } = useFormContext<TravelRequestSchema>();
  const expenses = useWatch({ control, name: 'expenses' });
  const checked = (expenses ?? []).some(expense => expense?.expenseType === 'UMFST_MOBILITY_SUPPORT');
  const absenceMotivation = useWatch({ control, name: 'absence.absenceMotivation' });

  // The support replaces every other expense line, and unticking does not bring them back.
  const toggle = (next: boolean) =>
    setValue('expenses', next ? [{ ...defaultTravelExpenseValues, expenseType: 'UMFST_MOBILITY_SUPPORT' }] : []);

  // Also runs on a loaded request, so a stored excluded motivation never hides behind the filtered select.
  useEffect(() => {
    if (checked && absenceMotivation != null && mobilitySupportExcludedMotivations.includes(absenceMotivation)) {
      setValue('absence.absenceMotivation', null);
    }
  }, [checked, absenceMotivation, setValue]);

  return (
    <Checkbox
      label={t('travel.requests.form.fields.mobilitySupport')}
      description={t('travel.requests.form.mobilitySupportProcedure')}
      checked={checked}
      disabled={isSubmitting}
      onChange={event => toggle(event.currentTarget.checked)}
    />
  );
}
